function addTag({ userId, metadataId, type, value }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/tags`;
  return apiClient.post(route, { userId, metadataId, type, value });
}

function removeTag({ userId, tagId, type }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/tags/${tagId}`;
  return apiClient.delete(route, { userId, type });
}

export default {
  addTag,
  removeTag
};



// WEBPACK FOOTER //
// ./app/api/TagsApi.js